module.exports = __webpack_public_path__ + "static/img/banner_mask.cc44c626.png";